export default __webpack_public_path__ + "static/media/home-magazine-img-03.4acac224.jpg";